import PropTypes from 'prop-types';
import React from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

import { toSlug } from 'utils';
import {localTimeShort, localFullDateLong, localFullDateNoDay} from 'utils/LocalDateTimeHelper';
import { canonicalLink } from 'utils/seoUtils';

import AdvertWrapper from 'modules/Common/components/AdvertWrapper';

import Dropdown from 'modules/Common/components/Dropdown';

require("./GreyhoundRacingRacePage.scss");

export default function GreyhoundRacingRacePage(props) {
  const {
    routes,
    children,
    meeting: raceMeeting,
    race, // for passing on
    race: {
      race_summary : {
        race_summary_reference: {
          id: raceId
        },
        course_name : courseName = '',
        date : dateLong = new Date(),
        time : raceTime
      }
    },
    meetings: {
      meetings = []
    } = {}
  } = props;

  const meetingsOnThisDay = meetings.map(({
      meeting_summary: {
        course: {
          name: courseName = ''
        }
      },
      races: [
        {
          race_summary_reference: {
            id: raceId
          }
        }
      ]
    }) => ({
      href: `/greyhounds/racecards/${dateLong}/${toSlug(courseName)}/racecard/${raceId}`,
      text: courseName
    })
  );

  const londonRaceTime = localTimeShort(`${dateLong}T${raceTime}Z`);
  const helmetDate = localFullDateNoDay(dateLong);
  const headingDate = localFullDateLong(dateLong);

  const helmetProps = {
    title: `${londonRaceTime} ${courseName} - ${helmetDate}`,
    ...canonicalLink(routes, {date: dateLong, courseSlug: toSlug(courseName), raceId})
  };

  return (
    <div className="gh-racing-racecard-wrapper">
      <MetaDataWrapper helmetProps={helmetProps}/>

      <section className="gh-racing-racecard-top-section">
        <div className="dropdown-wrapper">
          <Dropdown title="Meetings" options={meetingsOnThisDay} shouldNavigate={true}/>
        </div>

        <h1>{londonRaceTime}&nbsp;{courseName} <small>{headingDate}</small></h1>
      </section>

      {children && React.cloneElement(children, { race, meeting: raceMeeting })}

      <AdvertWrapper ocSlot={["greyhounds", "leaderboard"]} additionalProperties={{view: "racecard"}} />
    </div>
  );
}

GreyhoundRacingRacePage.propTypes = {
  routes: PropTypes.array.isRequired,
  race : PropTypes.object.isRequired,
  meeting: PropTypes.object,
  meetings: PropTypes.object,
  children: PropTypes.node
};



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/components/GreyhoundRacingRacePage.js